/**
 * 股东/董事信息 - 表单默认值工厂 & 回显数据归一化
 * 弹窗初始化(AddOrUpdate)、回显平铺展示(index.vue) 共用，
 * 保证表单字段结构完整，避免模板访问 undefined 报错(如 representativeInfo.fullName)
 */

// ==================== 表单默认值工厂函数 ====================
export const createRepresentativeInfo = () => ({
  fullName: null,
  nationality: null,
  identificationType: null,
  identificationNo: null,
  email: null,
  phone: "",
  residentialAddress: null,
  birthDate: null,
});

export const createCompanyForm = () => ({
  memberType: "CORPORATE",
  positionHeld: "SHAREHOLDER",
  fullName: null,
  nationality: null,
  businessLicenseNo: null,
  phone: "",
  email: null,
  registeredOfficeAddress: null,
  operationAddress: null,
  information: null,
  addressIdUrls: [],
  businessLicenseUrls: [],
  identificationUrls: [],
  sharesInfo: [],
  incorporationDate: null,
  isNominatedShareholder: 0,
  representativeInfo: createRepresentativeInfo(),
  // 马来西亚专属 - 公司额外信息
  entityType: null,
  companyRegistrationNumber: null,
  companyType: null,
  placeOfIncorporation: null,
  // 马来西亚专属 - 注册地址
  registeredAddressLine1: null,
  registeredAddressLine2: null,
  registeredAddressLine3: null,
  registeredAddressCity: null,
  registeredAddressState: null,
  registeredAddressPostalCode: null,
  registeredAddressCountry: null,
  // 马来西亚专属 - 服务地址 (1=与注册地址相同, 2=其他地址)
  serviceAddressType: 2,
  serviceAddressLine1: null,
  serviceAddressLine2: null,
  serviceAddressLine3: null,
  serviceAddressCity: null,
  serviceAddressState: null,
  serviceAddressPostalCode: null,
  serviceAddressCountry: null,
});

export const createPersonalForm = () => ({
  memberType: "INDIVIDUAL",
  positionHeld: "SHAREHOLDER",
  fullName: null,
  nationality: null,
  identificationType: null,
  identificationNo: null,
  email: null,
  phone: "",
  residentialAddress: null,
  information: null,
  addressIdUrls: [],
  businessLicenseUrls: [],
  identificationUrls: [],
  sharesInfo: [],
  birthDate: null,
  isNominatedShareholder: 0,
  isNominatedDirector: 0,
  directorNeedResigned: 0,
  isHoldShareOfPrcInland: 0,
  holdShareOfPrcEntity: null,
  // 马来西亚专属 - 个人额外信息
  gender: null,
  occupation: null,
  race: null,
  // 马来西亚专属 - 居住地址
  residentialAddressLine1: null,
  residentialAddressLine2: null,
  residentialAddressLine3: null,
  residentialAddressCity: null,
  residentialAddressState: null,
  residentialAddressPostalCode: null,
  residentialAddressCountry: null,
  // 马来西亚专属 - 服务地址 (1=与居住地址相同, 2=其他地址)
  serviceAddressType: 2,
  serviceAddressLine1: null,
  serviceAddressLine2: null,
  serviceAddressLine3: null,
  serviceAddressCity: null,
  serviceAddressState: null,
  serviceAddressPostalCode: null,
  serviceAddressCountry: null,
});

// ==================== 回显数据归一化 ====================
/**
 * 公司类型 - 回显数据归一化：补全缺失字段与嵌套对象
 * row 来自后端/父组件 value，字段可能缺失，直接渲染会导致
 * v-model="form.representativeInfo.fullName" 访问 undefined 报错
 */
export const normalizeCompanyForm = row => ({
  ...createCompanyForm(),
  ...row,
  representativeInfo: { ...createRepresentativeInfo(), ...(row.representativeInfo || {}) },
  sharesInfo: Array.isArray(row.sharesInfo) ? row.sharesInfo : [],
});

/** 个人类型 - 回显数据归一化 */
export const normalizePersonalForm = row => ({
  ...createPersonalForm(),
  ...row,
  sharesInfo: Array.isArray(row.sharesInfo) ? row.sharesInfo : [],
});
